<div class="deparment-dialoge">
  <h3 mat-dialog-title class="popHead" style="padding-left: 5px">View Job Description</h3>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close mat-raised-button color="primary">Close</button>
  </mat-dialog-actions>

  <div class="view_document_body" [innerHTML]="data?.descripition"></div>
</div>